<template>
  <div class="register ">
    <headd></headd>
    <indexswiper :swiper_list="swiper_list"></indexswiper>
    <div class="register_recommd container">
      <div class="container-head">
        <div class="head-left">
          <div class="icon">
            <img src="../../static/otherpage/icon_t_1.png" />
          </div>
          热门专区
        </div>
      </div>
      <modulelist2 :modulelist="regCombo"></modulelist2>
    </div>
    <div class="register_recommd container">
      <div class="container-head">
        <div class="head-left">
          <div class="icon">
            <img src="../../static/otherpage/icon_t_5.png" />
          </div>
          其他服务
        </div>
      </div>
      <modulelist2
        :modulelist="regServiceCombo"
        :is_show="is_show"
      ></modulelist2>
    </div>

    <dynamicimg :datainfo="dy_title_t1"></dynamicimg>
    <anews :datainfo="dy_title_t2"></anews>
    <dynamicimg :datainfo="dy_title_t3"></dynamicimg>
    <maybe :is_include="name"></maybe>
    <foot></foot>
  </div>
</template>

<script>
import indexswiper from "../components/indexswiper";
import modulelist2 from "../components/modulelist2";
import dynamicimg from "../components/dynamicimg.vue";
import anews from "../components/anews.vue";
import maybe from "../components/maybe.vue";
import headd from "../components/head";
import foot from "@/components/foot";
import {
  getregCombobanner,
  getregCombo,
  getregServiceCombo,
  getregPageData
} from "./api/api"; //引入api里面定义的方法

export default {
  data() {
    return {
      is_show: true,
      name: "公司注册",
      dy_title_t1: {
        icon: "../../static/otherpage/icon_t_4.png",
        title: "",
        pagevalue: ""
      },
      dy_title_t2: {
        icon: "../../static/otherpage/icon_t_6.png",
        title: "",
        pagevalue: {}
      },
      dy_title_t3: {
        icon: "../../static/otherpage/icon_t_7.png",
        title: "",
        pagevalue: ""
      },
      indicatorDots: true,
      autoplay: true,
      interval: 2000,
      duration: 500,
      indicatorColor: "rgba(255, 255, 255, .3)",
      indicatorActivecolor: "#FFFFFF",
      swiper_list: [],
      regCombo: [],
      regServiceCombo: [],
      regPageData: []
    };
  },
  metaInfo: {
    title: "马上创业网 专注企业注册的网站", // set a title
    meta: [
      {
        // set meta
        name: "keyWords",
        content:
          "马上创业网，注册公司，代理记账，上海注册公司，注册公司流程，注册公司费用，商标注册，法务咨询，法律服务，个体工商户注册，许可证办理，专业法律，社保，公积金，专利申请，医疗器械许可证，ICP电信增值许可证，食品经营许可证，酒类经营许可证，餐饮服务许可证，道路运输许可证，广播电视节目许可证，海关资质，进出口许可证，商标设计，logo设计，VI设计，海报设计，包装设计，APP开发，微信运营，网站定制，版权服务，软件著作权，发明专利，外观设计专利，实用新型专利，商标转让，驳回复审，注销公司，股权变更，经营范围变更，股权协议，股权转让，劳务派遣"
      },
      {
        name: "description",
        content:
          "马上创业网是一个专为中小企业服务的综合平台，主要提供医疗器械服务、审计服务、知识产权服务、财税咨询、注册公司、代理记账、商标注册、专利申请、社保代理、法务代理等一站式的服务，借助移动互联网技术，改善并升级企业服务状态，实现了新形势下中小企业所需要的企业服务。"
      }
    ]
  },
  components: {
    indexswiper,
    modulelist2,
    dynamicimg,
    anews,
    maybe,
    headd,
    foot
  },
  metaInfo: {
    title: "公司注册-马上创业网 专注企业注册的网站", // set a title
    meta: [
      {
        // set meta
        name: "keyWords",
        content:
          "上海公司注册,杭州公司注册,成都公司注册,北京公司注册,沈阳公司注册,宁波公司注册,注册公司,公司注册,代办公司注册,注册公司费用及流程,代理注册公司,代理注册,马上创业网提供上海公司注册,版权登记,软件著作权,注册公司,公司注册,代办公司注册,注册公司费用及流程,代理注册公司,代理注册等服务,马上创业网,专注公司注册的网站,提供一站式的公司注册服务,劳务派遣,个人社保,企业社保,创业法律服务"
      },
      {
        name: "description",
        content:
          "马上创业网，专注公司注册的网站，提供一站式的公司注册服务，劳务派遣，个人社保,企业社保,创业法律服务"
      }
    ]
  },
  async mounted() {
    var swiperr = await getregCombobanner();
    this.swiper_list = swiperr.data.data.banner;
    this.$nextTick(function() {
      this.swiper();
    });

    var regCombo = await getregCombo();
    this.regCombo = regCombo.data.data.regCombo;

    var regServiceCombo = await getregServiceCombo();
    this.regServiceCombo = regServiceCombo.data.data.serviceCombo;

    var regPageData = await getregPageData();
    var data = regPageData.data.data;

    this.dy_title_t1 = data.t1;
    this.dy_title_t2 = data.t2;
    this.dy_title_t3 = data.t3;
    this.$set(this.dy_title_t1, "icon", "../../static/otherpage/icon_t_4.png");
    this.$set(this.dy_title_t2, "icon", "../../static/otherpage/icon_t_6.png");
    this.$set(this.dy_title_t3, "icon", "../../static/otherpage/icon_t_7.png");
  },
  methods: {
    swiper() {
      new Swiper(".banner", {
        loop: true,
        observer: true,
        pagination: ".swiper-pagination",
        paginationClickable: true,
        autoplay: 5000
      });
    }
  }
};
</script>

<style lang="less">
.container {
  //   margin: 30rpx 32rpx;
  //   width: 686rpx;
  padding: 0 0.15rem;
  @media (max-width: 991px) {
    padding: 0 !important;
  }
}
.register {
  flex-direction: column;
  @media (max-width: 991px) {
    width: 6.86rem;
  }
  margin: auto;

  .register_recommd {
    flex-direction: column;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/companyregister.vue